import {
  SerializeMap,
  buildDeserializer,
  buildSerializer,
} from "lib/serializerUtils";

export const sundryTemplateSerializerMap: SerializeMap<SundryTemplate> = {
  id: "id",
  created: "created",
  emailAttachmentsToPaidToBusiness: "email_attachments_to_paid_to_business",
  emailAttachmentsToPaidFromBusiness: "email_attachments_to_paid_from_business",
  glCode: "gl_code",
  gstMethod: "gst_method",
  labels: "labels",
  templateLabel: "template_label",
  lastModified: "last_modified",
  name: "name",
  note: "note",
  paidFromBusinessId: "paid_from_business_id",
  paidFromSearchFilter: "paid_from_search_filter",
  paidFromType: "paid_from_type",
  paidToBusinessId: "paid_to_business_id",
  paidToSearchFilter: "paid_to_search_filter",
  paidToType: "paid_to_type",
  taxType: "tax_type",
  quickSelect: "quick_select",
  permissions: "permissions",
  groupLineItems: "group_line_items",
};

export const serializeSundryTemplate = buildSerializer<SundryTemplate>(
  sundryTemplateSerializerMap,
  "sundryTemplate",
);

export const deserializeSundryTemplate = buildDeserializer<SundryTemplate>(
  sundryTemplateSerializerMap,
  "sundryTemplate",
);
